import React from 'react';
import PalletPlanning from './PalletPlanning';

interface containerProps {
  palletNo: number
}

const ContainerInterior: React.FC<containerProps> = ({ palletNo }) => {

  const pallets: number[] = [];
  const containerLength = 5;
  const containerWidth = 2;

  for(let i = 0; i< palletNo; i++){
    pallets.push(i);
  }

  const totalPallets = pallets.length;

  return (
    <div style={{ width: '100%', height: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <svg width="320"
        height="280"
        viewBox={`0 0 320 ${totalPallets > 20 ? 265 : 280}`}
        xmlns="http://www.w3.org/2000/svg">
        <g transform="rotate(180,160,140)">

          <polygon points={`286.6,${totalPallets > 20 ? 170 : 150} 113.4,${totalPallets > 20 ? 270 : 250} 113.4,190 286.6,90`}
            fill="#f0f0f0"
            stroke="#000000"
            strokeWidth="1"/>

          <polygon points={`26.8,${totalPallets > 20 ? 218 : 200} 113.4,${totalPallets > 20 ? 270 : 250} 113.4,190 26.8,140`}
            fill="#fbfbfb"
            stroke="#1c0f0fff"
            strokeWidth="1"/>
    
          <polygon points="200,40 286.6,90 113.4,190 26.8,140"
            fill="#b0b0b0" 
            stroke="#000000"
            strokeWidth="1"/>
        </g>
        {pallets.map(p => 
          <PalletPlanning key={p}
            containerLength={containerLength}
            containerWidth={containerWidth}
            palletNo={p} />)}
      </svg>
    </div>
  );
};

export default ContainerInterior;